import Dexie, { liveQuery, Table } from 'dexie';
import { Observable, from } from 'rxjs';
import { ClientRecognitionState, Dashboard, Image, ImageRecognition, RecognitionDetails } from './model';
import { Dashboards } from '../models/dashboards';
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class APPDB extends Dexie {
    image!: Table<Image, number>
    recognition!: Table<ImageRecognition, number>
    recognition_details!: Table<RecognitionDetails, number>
    dashboards!: Table<Dashboard, string>

    constructor() {
        super('workspaceapp');
        this.version(2).stores({
            image: '++id',
            recognition: '++id, recognition_id, file_name, image_id, local_image_id',
            recognition_details: '++id, recognition_id'
        });

        this.version(3).stores({
            dashboards: '++id, &uid'
        });

    }



    async addImageRecognitions(recognitions: ImageRecognition[]): Promise<number> {
        return this.recognition.bulkAdd(recognitions);
    }
    async addRecognitionDetails(recognitions_details: RecognitionDetails[]): Promise<number> {
        return this.recognition_details.bulkPut(recognitions_details);
    }

    async setRecognitionDetails(recognitions_details: RecognitionDetails[]): Promise<void> {

        await this.transaction('rw', this.recognition_details, async () => {
            const keys = recognitions_details.map(d => d.recognition_id);
            const existingRecords = await this.recognition_details
                .where('recognition_id')
                .anyOf(keys)
                .toArray();

            const recordMap = new Map(
                existingRecords.map(r => [r.image.image_id, r])
            );

            for (const detail of recognitions_details) {
                const key = detail.image.image_id;
                if (recordMap.has(key)) {
                    await this.recognition_details.update(recordMap.get(key)!.id!, { id: recordMap.get(key)!.id!, ...detail });
                } else {
                    console.log('value detail', detail)

                    await this.recognition_details.add(detail);
                }
            }
        });
    }
    async getCombinedRecognitionDetails(): Promise<any[]> {
        const recognitionData = await this.recognition.toArray();
        const recognitionDetailsData = await this.recognition_details.toArray();
        const combinedData = recognitionData.map((recognition) => {
            const details = recognitionDetailsData.find((detail) => detail.recognition_id === recognition.recognition_id);
            const { task_id, task_key, veredict } = details || {};
            return { ...recognition, task_id, task_key, veredict };
        });

        return combinedData;
    }


    getRecognitionDetailsLive(recognition_id: string) {
        return from(liveQuery(() => this.recognition_details.where('recognition_id').equals(recognition_id).toArray()));
    }

    getImagesByIdsLive(ids: number[]) {
        return from(liveQuery(() => this.image.where('id').anyOf(ids).toArray()));
    }
    async getImagesByIds(ids: number[]): Promise<Image[]> {
        return this.image.where('id').anyOf(ids).toArray();
    }
    async getImageRecognition(key: string, value: any) {
        // console.log(key, value)
        return this.recognition.where(key).equals(value).toArray();
    }
    async getImageRecognitions(key: string, values: any) {
        // console.log(key, values)
        return this.recognition.where(key).anyOf(values).toArray();
    }
    async getImagesRecogitionsByRecognititionId(recognition_id: string): Promise<ImageRecognition[]> {
        return this.recognition.where('recognition_id').equals(recognition_id).toArray();
    }
    getImagesRecogitionsByRecognititionIdLive(recognition_id: string): Observable<ImageRecognition[]> {
        return from(liveQuery(() => this.recognition.where('recognition_id').equals(recognition_id).toArray()));
    }

    getAllImageRecognition(): Promise<ImageRecognition[]> {
        return this.recognition.toArray();
    }
    getImages(): Observable<Image[]> {
        return from(liveQuery(() => db.image.toArray()))
    }
    async deleteImageAndRecognition(localImageId: number): Promise<void> {
        try {
            await this.image.delete(localImageId);
            const recognitions = await this.recognition.where('local_image_id').equals(localImageId).toArray();
            if (recognitions.length > 0) {
                await Promise.all(
                    recognitions.map(async (recognition) => {
                        if (recognition.id !== undefined) {
                            await this.recognition.delete(recognition.id);
                        } else {
                            console.warn(`Recognition sin id válido encontrada:`, recognition);
                        }
                    })
                );
            }
        } catch (error) {
            console.error('Error al eliminar la imagen o el reconocimiento:', error);
        }
    }


    async saveDashboard(uid: string, type: any, render: string) {
        try {
            
            const existente = await this.dashboards.where('uid').equals(uid).first();
            const datos: Dashboard = {
                uid: uid,
                type: type,
                milisec: Date.now(),
                render: render
            };
            if (existente) {
                datos.id = existente.id;
            }

            // 4. GUARDAR (put)
            await this.dashboards.put(datos);
            console.log(existente ? 'Actualizado' : 'Creado nuevo');

        } catch (error) {
            console.error('Error guardando:', error);
            throw error;
        }
    }


    async getDashL(uid: string) {
        try {
            const resultado = await this.dashboards.where('uid').equals(uid).first();

            return resultado;
        } catch (error) {
            console.error('Error al consultar dashboard:', error);
            throw error;
        }
    }
    async updateDash(uid: string, newRender: string) {
        console.log('actualziando dash');
        
        return await this.dashboards
            .where('uid')
            .equals(uid)
            .modify({
                render: newRender,
                milisec: Date.now() 
            });
    }
}

export const db = new APPDB();
